import React from 'react'
import PropTypes from 'prop-types'
// import { alertOptions } from '../../../../resources/utilities'
// import AlertContainer from 'react-alert'

import {polyglot} from '../../../../index'
import PanelWithContent from '../../../common/PanelWithContent/PanelWithContent'
import BiggerScreenMessage from '../../../common/BiggerScreenMessage/BiggerScreenMessage'
import TeethView from '../../Home/TeethView/TeethView'

class FinalConsultation extends React.Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = {
      teeth: props.teethStatus || {}
    }
  }

  componentWillReceiveProps (props) {
    if (props.consultationData && props.consultationData !== null) {
      this.setState({
        consultationDetails: props.consultationData.consultationDetails
      })
    }
    this.setState({
      teeth: props.teethStatus || {}
    })
  }

  handleSubmit (data, key) {
    this.props.handleChange(data)
  }

  renderConsultationDate () {
    if (this.props.formConfig.details.status) {
      const element = this.props.formConfig.details.status
      return <PanelWithContent
        dataKey={element.key}
        savedData={this.props.consultationData}
        saveData={this.handleSubmit}
        title={element.title}
        extraFieldContent={element.extraFieldContent}
        fields={element.fields}
        extraFieldEnabled={element.isExtraFieldEnabled} />
    } else {
      return <div>Loading</div>
    }
  }

  render () {
    return (
      <div>
        {this.props.patientKey
          ? <div>
            <div className='page-header'>
              <h2>{polyglot.t('staticText.finalConsultation')}</h2>
            </div>
            {/* <AlertContainer ref={a => { this.msg = a }} {...alertOptions} /> */}
            <BiggerScreenMessage />
            <div className='big-screen-only'>
              {this.state.teeth
                ? <TeethView key={`${this.props.patientKey}_${this.props.age}`} currentAgeTeeth={this.props.availableTeeth} teethStatus={this.state.teeth} currentAge={this.props.age} patientKey={this.props.patientKey} />
                : null
              }
            </div>
            <div>
              {this.renderConsultationDate()}
            </div>
          </div>
        : null
        }
      </div>
    )
  }
}

FinalConsultation.defaultProps = {
  data: {
    consultationData: {
      teethStatus: {}
    }
  }
}

FinalConsultation.propTypes = {
  teethStatus: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  consultationData: PropTypes.object,
  patientKey: PropTypes.string.isRequired,
  formConfig: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  age: PropTypes.string.isRequired
}

export default FinalConsultation



// WEBPACK FOOTER //
// ./src/components/general/Age/FinalConsultation/FinalConsultation.js